// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani Chethana
 * @Date 28/01/2025
 */

.redFooter_redFooterOuterContainer__Q0m0O{
    margin: 120px 0px;
}
.redFooter_redFooterImage__TBvXn{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    
}
.redFooter_circleBlue__W8ca7{
    position: absolute;
    width: 300px;
    height: 300px;
    margin-left: -10px;
    background-color: #051286;
    border-radius: 50%;
    z-index: 2;
}
.redFooter_circleBlack__xtZxk{
    position: relative;
    width: 600px;
    height: 600px;
    background-color: rgb(38, 38, 38);
    border-radius: 50%;
    overflow: hidden;
    z-index: 1;
}
.redFooter_image__kAg4-{
    position: absolute;
    z-index: 3;
    
    /* top: ; */
}
.redFooter_redFooterPayStoreBtn__ROYSk{
    display: flex;
    flex-direction: row;
    justify-content: start;
    padding-left: 50px;
    
}
.redFooter_payStoreBtn__12pDU{
    width: 200px;
}
@media (min-width: 771px) {
    .redFooter_footerContainer__CkLlc {
        display: flex;
        width: 100%; 
        height: 154px; 
        align-items: center;
        justify-content: space-between;
        background: linear-gradient(90deg, #A61012 31.33%, #FF2155 102.43%);
    }

    .redFooter_text__QYcpb {
        color: #F5F5F7;
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
        margin-left: 3rem; 
        margin-right: 10%;
    }

    /* .button {
        background-color: white; 
        color: FF0000; 
        font-size: 20px; 
        padding: 5px 40px;
        margin-right: 3rem;
    } */
}

/* for mobile */
@media (max-width: 770px) {
    .redFooter_footerContainer__CkLlc {
        display: flex;
        flex-direction: column;
        width: 100%; 
        /* height: 154px; */
        padding: 1rem;
        justify-content:center;
        align-items: center;
        background: linear-gradient(90deg, #A61012 31.33%, #FF2155 102.43%);
    }

    .redFooter_text__QYcpb {
        color: #F5F5F7;
        font-size: 1rem;
        font-style: normal;
        font-weight: 600;

    }
    .redFooter_payStoreBtn__12pDU{
        width: 100px;
    }
    .redFooter_image__kAg4-{
        width: 300px;
    }

    .redFooter_circleBlue__W8ca7{
        width: 200px;
        height: 200px;
    }
    .redFooter_circleBlack__xtZxk{
        position: relative;
        width: 300px;
        height: 300px;
    }
    .redFooter_redFooterImage__TBvXn{
        margin-top: 100px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/footer/redFooter.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;AAEtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,UAAU;;IAEV,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;;AAEtB;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,aAAa;QACb,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,mEAAmE;IACvE;;IAEA;QACI,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;;;;;;OAMG;AACP;;AAEA,eAAe;AACf;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,mBAAmB;QACnB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mEAAmE;IACvE;;IAEA;QACI,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,gBAAgB;;IAEpB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;IACjB;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Shalani Chethana\r\n * @Date 28/01/2025\r\n */\r\n\r\n.redFooterOuterContainer{\r\n    margin: 120px 0px;\r\n}\r\n.redFooterImage{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    \r\n}\r\n.circleBlue{\r\n    position: absolute;\r\n    width: 300px;\r\n    height: 300px;\r\n    margin-left: -10px;\r\n    background-color: #051286;\r\n    border-radius: 50%;\r\n    z-index: 2;\r\n}\r\n.circleBlack{\r\n    position: relative;\r\n    width: 600px;\r\n    height: 600px;\r\n    background-color: rgb(38, 38, 38);\r\n    border-radius: 50%;\r\n    overflow: hidden;\r\n    z-index: 1;\r\n}\r\n.image{\r\n    position: absolute;\r\n    z-index: 3;\r\n    \r\n    /* top: ; */\r\n}\r\n.redFooterPayStoreBtn{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: start;\r\n    padding-left: 50px;\r\n    \r\n}\r\n.payStoreBtn{\r\n    width: 200px;\r\n}\r\n@media (min-width: 771px) {\r\n    .footerContainer {\r\n        display: flex;\r\n        width: 100%; \r\n        height: 154px; \r\n        align-items: center;\r\n        justify-content: space-between;\r\n        background: linear-gradient(90deg, #A61012 31.33%, #FF2155 102.43%);\r\n    }\r\n\r\n    .text {\r\n        color: #F5F5F7;\r\n        font-size: 30px;\r\n        font-style: normal;\r\n        font-weight: 600;\r\n        line-height: 150%;\r\n        margin-left: 3rem; \r\n        margin-right: 10%;\r\n    }\r\n\r\n    /* .button {\r\n        background-color: white; \r\n        color: FF0000; \r\n        font-size: 20px; \r\n        padding: 5px 40px;\r\n        margin-right: 3rem;\r\n    } */\r\n}\r\n\r\n/* for mobile */\r\n@media (max-width: 770px) {\r\n    .footerContainer {\r\n        display: flex;\r\n        flex-direction: column;\r\n        width: 100%; \r\n        /* height: 154px; */\r\n        padding: 1rem;\r\n        justify-content:center;\r\n        align-items: center;\r\n        background: linear-gradient(90deg, #A61012 31.33%, #FF2155 102.43%);\r\n    }\r\n\r\n    .text {\r\n        color: #F5F5F7;\r\n        font-size: 1rem;\r\n        font-style: normal;\r\n        font-weight: 600;\r\n\r\n    }\r\n    .payStoreBtn{\r\n        width: 100px;\r\n    }\r\n    .image{\r\n        width: 300px;\r\n    }\r\n\r\n    .circleBlue{\r\n        width: 200px;\r\n        height: 200px;\r\n    }\r\n    .circleBlack{\r\n        position: relative;\r\n        width: 300px;\r\n        height: 300px;\r\n    }\r\n    .redFooterImage{\r\n        margin-top: 100px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"redFooterOuterContainer": `redFooter_redFooterOuterContainer__Q0m0O`,
	"redFooterImage": `redFooter_redFooterImage__TBvXn`,
	"circleBlue": `redFooter_circleBlue__W8ca7`,
	"circleBlack": `redFooter_circleBlack__xtZxk`,
	"image": `redFooter_image__kAg4-`,
	"redFooterPayStoreBtn": `redFooter_redFooterPayStoreBtn__ROYSk`,
	"payStoreBtn": `redFooter_payStoreBtn__12pDU`,
	"footerContainer": `redFooter_footerContainer__CkLlc`,
	"text": `redFooter_text__QYcpb`
};
export default ___CSS_LOADER_EXPORT___;
